<template>
    <div>
        <div class="kgr-row">
            {{ $t('physicalAccess.rules.intro') }}
        </div>
        <kgr-empty-data
            v-if="rules.length === 0 && !loading"
            :value="$t('Es wurden noch keine Zutrittsregeln definiert.')"
        />
        <div>
            <kgr-loader v-if="loading" />
            <div v-else>
                <table class="kgr-table kgr-table--striped kgr-table--block table-groups kgr-row">
                    <thead>
                        <tr class="kgr-table__row">
                            <th class="kgr-table__cell kgr-table__cell--headline">
                                {{ $t('Bezeichnung') }}
                            </th>
                            <th class="kgr-table__cell kgr-table__cell--headline">
                                {{ $t('Terminals') }}
                            </th>
                            <th class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--actions kgr-table__cell--noGrow"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(rule, index) in rules"
                            :key="index"
                            class="kgr-table__row"
                        >
                            <td class="kgr-table__cell">
                                {{ rule.name }}
                            </td>
                            <td class="kgr-table__cell">
                                {{ rule.assignments.map(assignment => assignment.terminal.name).join(', ') }}
                            </td>
                            <td class="kgr-table__cell kgr-table__cell--actions kgr-table__cell--actions kgr-table__cell--noGrow">
                                <kgr-icon-edit
                                    v-if="isEditable"
                                    :size="15"
                                    class="kgr-table__action"
                                    @click="edit(rule)"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import EmptyData from '../../components/common/EmptyData';
import IconEdit from '../../components/common/icon/IconEdit';
import Loading from '../../components/common/Loading';
import PhysicalAccessRuleRepository from '../../js/repository/PhysicalAccessRuleRepository';

export default {
    components: {
        'kgr-loader': Loading,
        'kgr-icon-edit': IconEdit,
        'kgr-empty-data': EmptyData,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            rules: [],
            newRuleName: '',
        }
    },
    created() {
        this.load();
    },
    methods: {
        load() {
            this.loading = true;
            PhysicalAccessRuleRepository
                .findByClub(this.clubId)
                .then(rules => {
                    this.rules = rules;
                    this.loading = false;
                });
        },
        edit(rule) {
            window.location.href = this.editUrl(rule);
        },
        editUrl(rule) {
            return `/backend/clubs/physical-access/rule/${rule.id}`;
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
